import * as twgl from "twgl-base.js";

const vertShader: string = `#version 300 es
precision mediump float;
in vec2 a_position;
//uniform int u_numberOfVertices;
uniform float u_time;

#define PI 3.141592653589793238462643383

void main() {
    
    gl_Position = vec4(a_position, 0.0, 1.0);

}`

const fragmentShader: string = `#version 300 es
precision mediump float;

uniform vec2 u_resolution;
uniform float u_time;
uniform sampler2D u_img;
#define PI 3.14159265358

out vec4 outColor;

void main()
{
    vec2 uv = gl_FragCoord.xy/u_resolution;
    //uv = uv + 0.5;
    //uv = uv + eightTrack(uv, u_time);
    //uv = uv - 0.5;
    //0 is at center, range is -1.0 <-> 1.0
    vec2 centeredUV = (uv * 2.0) - 1.0;
    
    //new origin for center UV
    vec2 cUV = vec2(centeredUV.x - 0.09, centeredUV.y + 0.05) * 2.0;
    //cUV = cUV + eightTrack(uv, u_time);
    //mcUV = rotMat * mcUV;
    vec3 col = vec3(0.0);
    
    float thickness = 0.04;
    float position = abs(sin(u_time))/1.8; //range 0.0 to sirka 0.55, 1 loop = 3.14 sek
    
    float ss = u_time * PI;
    float angle = 0.0;
    
    if (mod(u_time, 3.0) < 0.5) {
    	angle = ss;
    	//position = 0.4;
    }
    mat2 rotMat = mat2(cos(angle), -sin(angle),
    				   sin(angle), cos(angle));
    cUV = rotMat * cUV;

    /*
    Mirrored(synmetry) coordinate system. I do it here because for rotation to work,
    we need negative numbers aswell, the rotaton will become strange if there are only
    positive numbers in all directions.
    */
    vec2 mcUV = abs(cUV);
    
    //x-axis -> Vertical lines
    float box = step(position, mcUV.x) * (1.0 - step(position + thickness, mcUV.x));
    //y-axis -> Horizontal lines
    box += step(position, mcUV.y) * (1.0 - step(position + thickness, mcUV.y));
    
    float boxInMiddle = (1.0 - step(position + thickness, mcUV.x)) * (1.0 - step(position + thickness, mcUV.y)); 
    
    float cutOffPoint = 0.7;
    //cutoff of line point
    box *= (1.0 - step(cutOffPoint, mcUV.x)) * (1.0 - step(cutOffPoint, mcUV.y)) ;
    
    //if (logo.b > 0.87 && logo.b < 0.9) {
    	//logo = vec4(0.0, 0.0, pow(abs(sin(u_time)), 3.0), 1.0);
    //}
    
    //vec4 rightNeighb = texelFetch(u_img, ivec2(gl_FragCoord.x + 1, gl_FragCoord.y), 0);
    col += box;
    col += (boxInMiddle * vec3(1.0, 230.0/255.0, 0.0));
    //col = mix(col, logo, 0.5);
    
    float waveTimer = mod(u_time, 3.0);
    uv = uv - 0.5;
    float d = length(sin(uv));
    d += sin((d*0.0 + d*1.0) - waveTimer/2.0)*1.0;
    d = smoothstep(0.0, 0.1, d) * (1.0 - smoothstep(0.1, 0.2, d));
    
    uv = uv + (d*0.009);
    uv = uv + 0.5;
    //uv = orig / 10.0;
    vec3 wave = vec3(0.0);
    wave += d;
    //d = 1.0 - d;
    vec3 logo = texture(u_img, uv).rgb;
    
    if (logo.b > 143.0/255.0) {
        discard;
    }
    //Everything outside of moving box should just be the logo texture
    if (box + boxInMiddle == 0.0) {
    	col = logo;
    }
    
    outColor = vec4(col, 1.0);
}`

let isRunning: boolean = false;
let renderLoop: any;
/*
    Creates and returns the WebGL loading logo as a canvas element
*/
export function getLoadingLogo(width: number, height: number): HTMLCanvasElement {

    const canvas: HTMLCanvasElement = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const gl: WebGL2RenderingContext | null = canvas.getContext("webgl2");
    //console.log(twgl.isWebGL2(gl))

    const programInfo = twgl.createProgramInfo(gl, [vertShader, fragmentShader]);

    const lmiBaseTex = twgl.createTexture(gl, {
        src: "assets/images/lmi_logo_v3_compressed.jpg",
        flipY: true
    })
    
    const arrays = {
        a_position: {numComponents: 2, data: [
                        -1, -1,
                        -1, 1,
                        1, -1,

                        1, -1,
                        1, 1,
                        -1, 1
                    ]}
    };

    const bufferInfo = twgl.createBufferInfoFromArrays(gl, arrays);

    const uniforms = {
        u_time: 0,
        u_resolution: [gl?.canvas.width, gl?.canvas.height],
        u_img: lmiBaseTex
    };

    function render(time: any) {
        //twgl.resizeCanvasToDisplaySize(gl.canvas);
        gl?.viewport(0, 0, gl.canvas.width, gl.canvas.height);

        const timeInSeconds: number = time * 0.001;
        uniforms.u_time = timeInSeconds,

        gl?.useProgram(programInfo.program);
        twgl.setBuffersAndAttributes(gl, programInfo, bufferInfo);
        twgl.setUniforms(programInfo, uniforms);
        twgl.drawBufferInfo(gl, bufferInfo);

        //console.log("animanimanaimanaianmaianiamainain")

        if (isRunning) requestAnimationFrame(render);   
    }


    //animationID = requestAnimationFrame(render);
    renderLoop = render;

    return canvas
}

export function startAnimation(): void {
    isRunning = true
    requestAnimationFrame(renderLoop)
}

export function pauseAnimation(): void {
    isRunning = false;
}